import { createSvgIcon } from "@mui/material/utils";

/**
 * Export icon.
 *
 * ![ExportIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi40IC0yLjQgMjQuOCAyNC44IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZjtib3JkZXItcmFkaXVzOjRweCI+PHBhdGggZD0iTTE3LjUgMTIuNVYxMy41QzE3LjUgMTQuOTAwMSAxNy41IDE1LjYwMDIgMTcuMjI3NSAxNi4xMzVDMTYuOTg3OCAxNi42MDU0IDE2LjYwNTQgMTYuOTg3OCAxNi4xMzUgMTcuMjI3NUMxNS42MDAyIDE3LjUgMTQuOTAwMSAxNy41IDEzLjUgMTcuNUg2LjVDNS4wOTk4NyAxNy41IDQuMzk5OCAxNy41IDMuODY1MDIgMTcuMjI3NUMzLjM5NDYyIDE2Ljk4NzggMy4wMTIxNyAxNi42MDU0IDIuNzcyNDggMTYuMTM1QzIuNSAxNS42MDAyIDIuNSAxNC45MDAxIDIuNSAxMy41VjEyLjVNMTQuMTY2NyA4LjMzMzMzTDEwIDEyLjVNMTAgMTIuNUw1LjgzMzMzIDguMzMzMzNNMTAgMTIuNVYyLjUiIHN0cm9rZT0iIzEwMTgyOCIgc3Ryb2tlLXdpZHRoPSIxLjY2NjY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD48L3N2Zz4=)
 */
const ExportIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M14.1667 8.33333L10 12.5M10 12.5L5.83333 8.33333M10 12.5V2.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Export"
);

export default ExportIcon;
